export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_UPDATE_QUANTITY = 'CART_UPDATE_QUANTITY';
export const CART_CLEAR = 'CART_CLEAR';
export const CART_TOGGLE_DRAWER = 'CART_TOGGLE_DRAWER';
